import React, { memo } from 'react';
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-4" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-4">
            Más los <span className="text-[#00B4D8]" data-id="element-5">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-gray-400 text-base" data-id="element-6">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-7">
          {/* Bono 1 */}
          <div className="bg-[#001a2d] border border-[#00B4D8] rounded-2xl p-6 flex flex-col" data-id="element-8">
            <div className="text-4xl font-black text-[#00B4D8] mb-1" data-id="element-9">01</div>
            <div className="text-[#00B4D8] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-10">
              🎁 BONO 1
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-11">
              Kit Domingo Cero
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-12">
              Planificás la semana en 12 minutos
            </p>
            <div className="flex items-center gap-2" data-id="element-13">
              <span className="text-gray-400 line-through text-sm" data-id="element-14">$8.000</span>
              <span className="bg-[#00B4D8] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-15">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-[#001a2d] border border-[#00B4D8] rounded-2xl p-6 flex flex-col" data-id="element-16">
            <div className="text-4xl font-black text-[#00B4D8] mb-1" data-id="element-17">02</div>
            <div className="text-[#00B4D8] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-18">
              🎁 BONO 2
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-19">
              Banco de Frases Salvavidas
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-20">
              300 instrucciones listas para el aula
            </p>
            <div className="flex items-center gap-2" data-id="element-21">
              <span className="text-gray-400 line-through text-sm" data-id="element-22">
                $10.000
              </span>
              <span className="bg-[#00B4D8] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-23">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-[#001a2d] border border-[#00B4D8] rounded-2xl p-6 flex flex-col" data-id="element-24">
            <div className="text-4xl font-black text-[#00B4D8] mb-1" data-id="element-25">03</div>
            <div className="text-[#00B4D8] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-26">
              🎁 BONO 3
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-27">
              Diagnóstico Relámpago
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-28">
              Resolvé el grupo mezclado en 1 clase
            </p>
            <div className="flex items-center gap-2" data-id="element-29">
              <span className="text-gray-400 line-through text-sm" data-id="element-30">$9.000</span>
              <span className="bg-[#00B4D8] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-31">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 4 */}
          <div className="bg-[#001a2d] border border-[#00B4D8] rounded-2xl p-6 flex flex-col" data-id="element-32">
            <div className="text-4xl font-black text-[#00B4D8] mb-1" data-id="element-33">04</div>
            <div className="text-[#00B4D8] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-34">
              🎁 BONO 4
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-35">
              Correcciones Inteligentes
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-36">
              120 comentarios listos, corregís en minutos
            </p>
            <div className="flex items-center gap-2" data-id="element-37">
              <span className="text-gray-400 line-through text-sm" data-id="element-38">$8.000</span>
              <span className="bg-[#00B4D8] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-39">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 5 */}
          <div className="bg-[#001a2d] border border-[#00B4D8] rounded-2xl p-6 flex flex-col" data-id="element-40">
            <div className="text-4xl font-black text-[#00B4D8] mb-1" data-id="element-41">05</div>
            <div className="text-[#00B4D8] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-42">
              🎁 BONO 5
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-43">
              Kit Participación Instantánea
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-44">
              25 activadores para que hablen francés
            </p>
            <div className="flex items-center gap-2" data-id="element-45">
              <span className="text-gray-400 line-through text-sm" data-id="element-46">$9.000</span>
              <span className="bg-[#00B4D8] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-47">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 6 */}
          <div className="bg-[#001a2d] border border-[#00B4D8] rounded-2xl p-6 flex flex-col" data-id="element-48">
            <div className="text-4xl font-black text-[#00B4D8] mb-1" data-id="element-49">06</div>
            <div className="text-[#00B4D8] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-50">
              🎁 BONO 6
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-51">
              Carpeta ProfePack
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-52">
              Sistema de organización listo para imprimir
            </p>
            <div className="flex items-center gap-2" data-id="element-53">
              <span className="text-gray-400 line-through text-sm" data-id="element-54">$9.000</span>
              <span className="bg-[#00B4D8] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-55">
                GRATIS
              </span>
            </div>
          </div>
        </div>

        <div className="border border-[#00B4D8]/40 rounded-2xl p-6 text-center bg-[#000d1a]" data-id="element-56">
          <p className="text-[#00B4D8] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-57">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-58">
            <span className="text-gray-400 line-through text-lg" data-id="element-59">$53.000</span>
            <span className="text-[#00B4D8] text-2xl font-black tracking-wide" data-id="element-60">
              🎁 GRATIS — Solo con tu MegaPack
            </span>
          </div>
          <p className="text-gray-400 text-sm" data-id="element-61">
            Incluidos en las ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}